import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <Container>
            <h1>Sorry, You are the outside of track</h1>
            <button> <Link to='/home'>Back to home</Link></button>
        </Container>
    );
};

export default NotFound;